import { render, staticRenderFns } from "./CardNewLabel.vue?vue&type=template&id=64a10b9c"
import script from "./CardNewLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardNewLabel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports